import React, { Component } from 'react';
import { Row, Col, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountUp } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

class DKPResourceItem extends Component {
    render() {
        return (
            <div>
            <Row>
                <Col md={2}>
                    <Link to={"/dkp/resources/" + this.props.resource.slug}><h5>{this.props.resource.title}</h5></Link>
                </Col>
                <Col md={2}>
                    <FontAwesomeIcon className="text-primary" size="sm" icon={faSortAmountUp} fixedWidth /> {this.props.resource.amount}
                </Col>
            </Row>
            </div>
        )
    }
}

export default DKPResourceItem;


// WEBPACK FOOTER //
// ./src/DKP/DKPResourceItem.js